import { injectable, inject } from "inversify";

import "reflect-metadata";
import IdentityService from "./identity.service";
import BaseFileSystemService from "./filesystem.base.service";

@injectable()
export default class FileSystemService extends BaseFileSystemService {
    @inject(IdentityService)
    public identity: IdentityService;

    protected getHeaders() {
        return {
            Authorization: `Bearer ${this.identity.getToken()}`,
        };
    }
    protected getFileImageName(): string {
        return "image";
    }

    protected private(): boolean {
        return false;
    }

    protected get uploadUrl() {
        return `image/`;
    }

    protected getUrl(id: string) {
        return `image/${id}/`;
    }
}



// WEBPACK FOOTER //
// ./src/services/filesystem.service.ts